export default {
  id: "contact-reference",
  name: "Contact Reference - New Contact",
  settings: {}
};
